import React__default, { useMemo, useEffect } from 'react';
import i18next from 'i18next';
import { initReactI18next, I18nextProvider } from 'react-i18next';
import languages from './locales/index.js';

var I18nProvider = function I18nProvider(_a) {
    var lang = _a.lang, children = _a.children;
    var instance = useMemo(function () {
        var i = i18next.createInstance();
        i.use(initReactI18next).init({
            fallbackLng: false,
            lng: lang,
            ns: ["refront-components"],
            defaultNS: "refront-components",
            keySeparator: false,
            interpolation: {
                escapeValue: false
            },
            react: {
                useSuspense: false
            }
        }, function () { return console.debug("i18n components initialized"); });
        return i;
    }, [lang]);
    useEffect(function () {
        console.debug("updating components language");
        instance.addResourceBundle(lang, "refront-components", languages[lang]["refront-components"]);
        instance.changeLanguage(lang);
    }, [lang, instance]);
    return React__default.createElement(I18nextProvider, { i18n: instance }, children);
};

export { I18nProvider as default };
//# sourceMappingURL=I18nProvider.js.map
